
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { clsx } from 'clsx';
import './InfoBox.css';
import capacity from '../assets/images/capacity.svg';
import length from '../assets/images/length.svg';
import width from '../assets/images/width.svg';
import { ShipData } from '../services/types';

type ShipInfoProps = {
  inDrawer?: boolean;
  selectedShip: ShipData | null;
}

const fleet: {[shipName: string]: string} = {
  Encore: "https://www.seabourn.com/en/us/cruise-ships/seabourn-encore/3",
  Quest: "https://www.seabourn.com/en/us/cruise-ships/seabourn-quest/4",
  Odyssey: "https://www.seabourn.com/en/us/cruise-ships/seabourn-odyssey/4",
  Ovation: "https://www.seabourn.com/en/us/cruise-ships/seabourn-ovation/3",
  Sojourn: "https://www.seabourn.com/en/us/cruise-ships/seabourn-sojourn/4",
  Venture: "https://www.seabourn.com/en/us/cruise-ships/seabourn-venture/1",
  Pursuit: "https://www.seabourn.com/en/us/cruise-ships/seabourn-pursuit/0",
};

const useStyles = makeStyles(theme => ({
  centerContainer: {
    margin: 'auto',
  },
  latLngTempContainer: {
  },
  latLngTempText: {
    color: '#9D7E47',
  },
  shipInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    height: '100%',
    padding: theme.spacing(1, 2),
    textAlign: 'center',
  },
  shipInfoDrawerContainer: {
    padding: '20px 20px 80px',
  },
  shipName: {
    color: '#304153',
    fontFamily: 'OpenSans',
    fontSize: '24px',
    lineHeight: '1.1904',
    letterSpacing: '.01563rem',
    margin: theme.spacing(0),
    textTransform: 'capitalize',
  },
  shipMetaText: {
    color: '#606060',
  },
  specsContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2),
  },
  spec: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  specIcon: {
    height: '35px',
    width: 'auto'
  },
  text: {
    fontFamily: 'OpenSans',
    fontSize: '14px',
    margin: theme.spacing(0),
  }
}));

export const ShipInfo = ({ inDrawer, selectedShip }: ShipInfoProps) => {
  const classes = useStyles();
  if (selectedShip === null) return null;

  return (
    <div className={clsx(classes.shipInfoContainer, inDrawer && classes.shipInfoDrawerContainer)}>
      <p className={clsx(classes.shipName)}>Seabourn {selectedShip.ShipName}</p>
      <div className={classes.latLngTempContainer}>
        {selectedShip.latitude && (
          <p className={clsx(classes.text, classes.latLngTempText)}>
            Latitude: {selectedShip.latitude}°
          </p>
        )}
        {selectedShip.longitude && (
          <p className={clsx(classes.text, classes.latLngTempText)}>
            Longitude: {selectedShip.longitude}°
          </p>
        )}
        {selectedShip.temperature && (
          <p className={clsx(classes.text, classes.latLngTempText)}>
            Temperature: {selectedShip.temperature} °C
          </p>
        )}
      </div>
      <div className={classes.centerContainer}>
        <div className={classes.specsContainer}>
          <div className={classes.spec}>
            <img className={classes.specIcon} alt="capacity" src={capacity} />
            <div>
              <p className={clsx(classes.text, classes.shipMetaText)}>{selectedShip.guests}</p>
              <p className={clsx(classes.text, classes.shipMetaText)}>Guests</p>
            </div>
          </div>
          <div className={classes.spec}>
            <img className={classes.specIcon} alt="length" src={length} />
            <div>
              <p className={clsx(classes.text, classes.shipMetaText)}>{selectedShip.length}ft</p>
              <p className={clsx(classes.text, classes.shipMetaText)}>Length</p>
            </div>
          </div>
          <div className={classes.spec}>
            <img className={classes.specIcon} alt="beam" src={width} />
            <div>
              <p className={clsx(classes.text, classes.shipMetaText)}>{selectedShip.width}ft</p>
              <p className={clsx(classes.text, classes.shipMetaText)}>Width</p>
            </div>
          </div>
        </div>
      </div>
      <button
        className="btn text center"
        onClick={() => { window.open(fleet[selectedShip.ShipName], '_blank'); }}>
        SHIP SAILINGS
      </button>
    </div>
  );
};